import React from "react";

const InfoCard = ({ 
  title, 
  icon, 
  children, 
  className = ""
}) => {
  return (
    <div className={`bg-white border border-gray-200 rounded-lg p-4 ${className}`}>
      <h3 className="text-sm font-semibold text-gray-900 mb-3 flex items-center">
        {icon && <span className="w-4 h-4 mr-2 text-orange-500">{icon}</span>}
        {title}
      </h3>
      <div className="space-y-2 text-xs">
        {children}
      </div>
    </div>
  );
};

const InfoRow = ({ label, value, className = "text-gray-900", badge = false, badgeVariant = null }) => {
  const getBadgeClasses = (variant) => {
    const baseClasses = "inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border";
    const variantClasses = {
      success: "bg-green-100 text-green-800 border-green-200",
      danger: "bg-red-100 text-red-800 border-red-200",
      warning: "bg-yellow-100 text-yellow-800 border-yellow-200",
      info: "bg-blue-100 text-blue-800 border-blue-200",
      gray: "bg-gray-100 text-gray-800 border-gray-200"
    };
    return `${baseClasses} ${variantClasses[variant] || variantClasses.gray}`;
  };

  return (
    <div className="flex justify-between items-center py-1 border-b border-gray-100 last:border-b-0">
      <span className="font-medium text-gray-700">{label}:</span>
      {badge ? (
        <span className={getBadgeClasses(badgeVariant)}>{value}</span>
      ) : (
        <span className={className}>{value}</span>
      )}
    </div>
  );
};

InfoCard.Row = InfoRow;

export default InfoCard;
